export const TABLE_HEAD: Array<HeadCellConfig> = [
  { id: 'index', label: 'STT' },
  { id: 'image', label: '' },
  { id: 'info', label: 'Thông tin sản phẩm' },
  { id: 'uom', label: 'Đơn vị' },
  { id: 'quantity', label: 'Số lượng' },
  { id: 'price', label: 'Giá trị', align: 'right' },
  { id: 'total', label: 'Tổng tiền', align: 'right' },
];
